<div  style="position: relative; z-index: 98" class="container-fluid">
  <ngb-alert (closed)="close('system')" *ngIf="AlertSystems.message && displayAlertSystem" [type]="AlertSystems.type">{{ AlertSystems.message }}</ngb-alert>
  <ngb-alert  (closed)="close('user')" *ngIf="AlertUser.message &&  displayAlertUser" [type]="AlertUser.type" >{{ AlertUser.message }}</ngb-alert>
</div>